import { ProductInfoBlockProps } from "./ProductInfoBlock.types";

import styles from "./ProductInfoBlock.module.scss";

const ProductInfoBlock = ({ title, children }: ProductInfoBlockProps) => {
  return (
    <div>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </div>
  );
};

export default ProductInfoBlock;
